// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"8dae121a507e79a2","8671":"ae5918e8c0dba860"}[chunkId] + ".css";
};